// Structural / non-translatable brand metadata. Translatable text lives in /i18n/translations.js
export const BRAND = {
    name: "606FITNESS",
    // Full wordmark logo (white) — for header, footer, CTA
    logo: "https://customer-assets.emergentagent.com/job_ai-trainer-59/artifacts/zfbbp84f_606%20FITNESS-07.png",
    // Icon-only mark (orange runner) — for hero card, favicon, accents
    icon: "https://customer-assets.emergentagent.com/job_ai-trainer-59/artifacts/d7ksjxep_606%20FITNESS-03.png",
};

// Parent / owning companies — shown as small credit logos in footer bottom
export const PARENT = {
    cloudGm: {
        name: "CLOUD GM FZ-LLC",
        logo: "https://customer-assets.emergentagent.com/job_ai-trainer-59/artifacts/gqocv7ra_Final%20606%20FITNESS-05.png",
    },
    asb606: {
        name: "ASB606 PLATFORMS GROUP",
        logo: "https://customer-assets.emergentagent.com/job_ai-trainer-59/artifacts/j1mvddjz_Original%20on%20transparent.png",
    },
};

// Nav sections — labels translated via i18n. `href` is the in-page anchor, `key` maps to translations.nav.<key>
export const NAV_LINKS = [
    { key: "features", href: "#features" },
    { key: "how", href: "#how" },
    { key: "stats", href: "#stats" },
    { key: "testimonials", href: "#testimonials" },
];

export const DOWNLOAD_LINKS = {
    apple: "#",
    google: "#",
    huawei: "#",
};

export const HERO_IMAGE =
    "https://static.prod-images.emergentagent.com/jobs/17398586-4cf3-4208-9544-06895382e117/images/8c76507277420e0493a02fcfedc65ec7ccdac6791710c627717ee727b0f211d7.png";

// Features — visual metadata only; titles and descs come from translations.features.items[id]
export const FEATURES = [
    {
        id: "ai",
        icon: "brain",
        image:
            "https://static.prod-images.emergentagent.com/jobs/17398586-4cf3-4208-9544-06895382e117/images/4ef34d8a817c0d46aadcc0219e1e617ca4d91c88edaf32b13fe3c734f039b784.png",
        span: "lg:col-span-2 lg:row-span-2",
    },
    {
        id: "workouts",
        icon: "dumbbell",
        image:
            "https://images.pexels.com/photos/19722863/pexels-photo-19722863.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        span: "lg:col-span-1",
    },
    {
        id: "progress",
        icon: "trending",
        image:
            "https://images.unsplash.com/photo-1512291152593-07033c65b791?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxwZXJzb24lMjBydW5uaW5nJTIwb3V0ZG9vcnMlMjBuaWdodCUyMHVyYmFufGVufDB8fHx8MTc4MDI1OTUyOXww&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-1",
    },
    {
        id: "nutrition",
        icon: "apple",
        image:
            "https://static.prod-images.emergentagent.com/jobs/17398586-4cf3-4208-9544-06895382e117/images/fd6303d29d4c7b82b1a7d81addc6499468db4325f7d66d072be0998f434833bb.png",
        span: "lg:col-span-1",
    },
    {
        id: "videos",
        icon: "play",
        image:
            "https://images.pexels.com/photos/14898419/pexels-photo-14898419.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        span: "lg:col-span-1",
    },
];
